import { useAuthQuery } from 'app/api_v2/auth/queries';
import { isClient } from 'app/helpers/userRoles';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface HasToBeClientGuardProps {
  children: React.ReactNode;
}

export const HasToBeClientGuard = (props: HasToBeClientGuardProps) => {
  const { children } = props;

  const { isSuccess, data } = useAuthQuery();

  if (isSuccess && !data) {
    return <Navigate to={'/auth/login'} />;
  }

  if (isSuccess && data && !isClient(data)) {
    return <Navigate to={'/dashboard'} />;
  }

  if (isSuccess) {
    return <>{children}</>;
  }
  return null;
};

export default HasToBeClientGuard;
